import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiArrowRight, FiMapPin } from "react-icons/fi";
import { BlogPost } from "../types";
import styles from "./PostCard.module.css";

interface Props {
  post: BlogPost;
  index: number;
  featured?: boolean;
}

export default function PostCard({ post, index, featured }: Props) {
  const formattedDate = new Date(post.date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <motion.article
      className={`${styles.card} ${featured ? styles.featured : ""}`}
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay: index * 0.1, ease: [0.16, 1, 0.3, 1] }}
    >
      <Link to={`/blog/${post.id}`} className={styles.link}>
        <div className={styles.imageWrap}>
          <motion.img
            src={post.coverImage}
            alt={post.title}
            className={styles.image}
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          />
          <div className={styles.imageOverlay} />
          <div className={styles.country}>{post.country}</div>
        </div>

        <div className={styles.content}>
          <div className={styles.meta}>
            <span className={styles.location}>
              <FiMapPin size={12} /> {post.location}
            </span>
            <span className={styles.date}>{formattedDate}</span>
          </div>

          <h3 className={styles.title}>{post.title}</h3>
          <p className={styles.excerpt}>{post.excerpt}</p>

          <div className={styles.tags}>
            {post.tags.slice(0, 3).map((tag) => (
              <span key={tag} className={styles.tag}>
                {tag}
              </span>
            ))}
          </div>

          <span className={styles.readMore}>
            Read Story <FiArrowRight size={14} />
          </span>
        </div>
      </Link>
    </motion.article>
  );
}
